import { render, staticRenderFns } from "./ArticleTimeline.vue?vue&type=template&id=071bc996&scoped=true"
import script from "./ArticleTimeline.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleTimeline.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticleTimeline.vue?vue&type=style&index=0&id=071bc996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071bc996",
  null
  
)

export default component.exports